export function getAuthBroadcastChannel() {
  return new BroadcastChannel('bolt-login');
}
